import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { formattedDate, closeModal } from "@lib/utils"

// Connects to data-controller="calendar-navigate"
export default class extends Controller {
  
  static targets = ["path"]

  static values = { closeModal: { type: Boolean, default: false } }

  onDateChange(e) {

    // Get the date and referrer values
    const date = formattedDate(e.detail.date)
    const referrer = this.pathTarget.value
    
    // Make a new URL object from the referrer value
    const url = new URL(referrer)
    
    // Update the date parameter of the existing url
    url.searchParams.set("date", date)
    
    // Visit the new URL with Turbo
    Turbo.visit(url.href, { action: "replace" })

    // Close the modal (if desired)
    if (this.closeModalValue) closeModal(this)
    
  }
  
}
